import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type TenantWidgetAccessViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  tenantValue: { displayId: string; id: string } | null;
  widgetValue: { displayId: string; id: string } | null;
  enabledValue?: { displayId: string; id: string } | null;
  enabled: boolean;
  configOverrideValue?: { displayId: string; id: string } | null;
  configOverride: string;
};

export const TenantWidgetAccessViewForm: React.FC<TenantWidgetAccessViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      tenantValue,
      widgetValue,
      enabled = false,
      configOverride = "{}",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupTenantWidgetAccessLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={langStore.TenantWidgetAccessTenantLabel}
                  selectedValue={langStore.displayIdByLang(
                    tenantValue?.displayId
                  )}
                />
                <ShowReference
                  label={langStore.TenantWidgetAccessWidgetLabel}
                  selectedValue={langStore.displayIdByLang(
                    widgetValue?.displayId
                  )}
                />
                <ShowBoolean
                  value={enabled}
                  label={langStore.TenantWidgetAccessEnabledLabel}
                />
                <InputCodeEditor
                  value={configOverride}
                  onChange={() => {}}
                  label={langStore.TenantWidgetAccessConfigOverrideLabel}
                  language="json"
                  readOnly={true}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
